import { Schema } from "effect";
import { JsonUnknownRecord } from "../json-unknown.js";
import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "effect/http-api";
import { UUID } from "../uuid.js";

export const AssetSourceTypeSchema = Schema.Literals([
  "annual_report",
  "annual_report_event",
  "buzz_article",
  "uploaded_file",
  "screenshot",
  "code_file",
  "web_page",
  "document",
]);

export const ASSET_SEARCH_MAX_OFFSET = 1_000;
const AssetSearchOffsetSchema = Schema.Int.pipe(
  Schema.check(Schema.isGreaterThanOrEqualTo(0)),
  Schema.check(Schema.isLessThanOrEqualTo(ASSET_SEARCH_MAX_OFFSET))
);

export const AssetSearchRequestSchema = Schema.Struct({
  query: Schema.String,
  sourceTypes: Schema.OptionFromOptional(Schema.Array(AssetSourceTypeSchema)),
  orgnr: Schema.OptionFromOptional(Schema.String),
  limit: Schema.OptionFromOptional(Schema.Int),
  offset: Schema.OptionFromOptional(AssetSearchOffsetSchema),
});

export const AssetSearchResultSchema = Schema.Struct({
  assetId: Schema.String,
  chunkId: Schema.String,
  sourceType: AssetSourceTypeSchema,
  sourceId: Schema.String,
  title: Schema.OptionFromOptional(Schema.String),
  snippet: Schema.String,
  score: Schema.Number,
  matchType: Schema.Literals(["vector", "full_text", "hybrid"]),
  metadata: JsonUnknownRecord,
});

export const AssetSearchResponseSchema = Schema.Struct({
  items: Schema.Array(AssetSearchResultSchema),
  limit: Schema.Int,
  offset: Schema.Int,
  schemaVersion: Schema.String,
  requestId: Schema.String,
});

export const AssetDocumentResponseSchema = Schema.Struct({
  assetId: Schema.String,
  sourceType: AssetSourceTypeSchema,
  sourceId: Schema.String,
  title: Schema.OptionFromOptional(Schema.String),
  orgnr: Schema.OptionFromOptional(Schema.String),
  sourceUri: Schema.OptionFromOptional(Schema.String),
  text: Schema.String,
  metadata: JsonUnknownRecord,
  schemaVersion: Schema.String,
  requestId: Schema.String,
});

export const AssetsV3Group = HttpApiGroup.make("assetsV3")
  .add(
    HttpApiEndpoint.post("searchAssets", "/assets/search", {
      payload: AssetSearchRequestSchema,
      success: AssetSearchResponseSchema,
      error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
    })
  )
  .add(
    HttpApiEndpoint.get("getAsset", "/assets/:assetId", {
      params: Schema.Struct({ assetId: UUID }),
      success: AssetDocumentResponseSchema,
      error: [
        HttpApiError.BadRequestNoContent,
        HttpApiError.NotFoundNoContent,
        HttpApiError.InternalServerErrorNoContent,
      ],
    })
  );
